import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { ApiRequestGet } from "../../../../../data/network/services/ApiRequestGet";
import { modififyDropdownServiceNameList } from "../../../../../services/fetchDropdownListData";
import { colorLightGrey } from "../../../../../utility/constants/colorManager";
import {
  RNC,
  RNCAPPROVED,
  RNCREJECTED,
  STATUS_CODE_200,
} from "../../../../../utility/constants/valueConstants";
import { CustomButton } from "../../../../components/main_comps/custom_button";
import { CustomInput } from "../../../../components/main_comps/custom_input/CustomInput";
import { CustomLoader } from "../../../../components/main_comps/custom_loader";
import ComissionContainer from "../../../../components/ui_comps/ComissionContainer";
import { useSnackbar } from "notistack";
import CommissionContainerPrefill from "../../../../components/ui_comps/CommissionContainerPrefill";

const inputStyle = {
  backgroundColor: "white",
  alignSelf: "center",
  height: 50,
  width: "100%",
  boxShadow: "none",
  outline: "none",
  paddingLeft: 10,
  borderRadius: 5,
  boxSizing: "border-box",
  alignItems: "center",
  display: "flex",
};
const textStyle = {
  fontSize: 16,
  fontWeight: 600,
  marginLeft: 10,
  // fontWeight: "500",
};

const checkboxStyle = {
  height: 20,
  width: 20,
};

const containerStyle = {
  padding: 0,
  maxWidth: 500,
  minWidth: 250,
  width: 350,
  height: "40px",
  border: "1px solid #CBCACA",
  borderRadius: "5px",
};
function CheckBoxInput({ title, value, onChange, checked, disabled }) {
  return (
    <div
      style={{
        backgroundColor: colorLightGrey,
        marginBottom: 5,
        ...inputStyle,
      }}
    >
      <input
        type="checkbox"
        style={{ ...checkboxStyle }}
        value={value}
        onChange={onChange}
        disabled={disabled}
        defaultChecked={checked}
      />

      <p style={{ ...textStyle }}>{title}</p>
    </div>
  );
}

const RadioButton = ({
  id,
  value,
  name,
  title,
  onChange,
  defaultChecked,
  style,
  disabled,
}) => {
  return (
    <div
      style={{
        ...style,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
      }}
    >
      <input
        type="radio"
        id={id}
        name={name}
        value={value}
        onChange={onChange}
        defaultChecked={defaultChecked}
        disabled={disabled}
        style={{
          margin: "0px 10px",
        }}
        checked={defaultChecked}
      />
      <label htmlFor={id}>{title}</label>
    </div>
  );
};

function ServiceType({
  role,
  clientData,
  isEditClicked,
  onChange,
  status,
  onChangeFileds,
  onChangeIpwhiteList,
}) {
  const [serviceProviderNamepayin, setServiceProviderNamepayin] = useState("");
  const [neokredRatepayin, setNeokredRatepayin] = useState("");
  const [serviceProviderRatepayin, setServiceProviderRatepayin] = useState("");
  const [serviceProviderNamepayout, setServiceProviderNamepayout] =
    useState("");
  const [neokredRatepayout, setNeokredRatepayout] = useState("");
  const [serviceProviderRatepayout, setServiceProviderRatepayout] =
    useState("");
  const [clientRatepayout, setClintratepayout] = useState("");
  const [clientRatepayin, setClintratepayin] = useState("");
  const [resellerRatepayout, setResellerratepayout] = useState("");
  const [resellerRatepayin, setResellerratepayin] = useState("");
  const [payin, setPayin] = useState({});
  const [payout, setPayout] = useState({});
  const [url, setUrl] = useState("");
  const [serviceType, setServiceType] = useState("");
  const [payinIpWhitelist, setPayinIpWhitelist] = useState("");
  const [payoutIpWhitelist, setPayoutIpWhitelist] = useState("");
  const [programs, setPrograms] = useState("");
  const [commissionRate1, setCommissionRate1] = useState([
    {
      from: "",
      to: "",
      value: "",
      type: "",
    },
  ]);
  const [flatData, setFlatData] = useState([]);
  const [type, setType] = useState("");
  const [commissionRate2, setCommissionRate2] = useState([]);
  const [flatData1, setFlatData1] = useState([]);
  const [type1, setType1] = useState("");
  const [loading, setLoading] = useState(false);
  const [urlValidate, setUrlValidate] = useState("");
  const [commType, setCommType] = useState("");
  const [notifyUrlPayin, setNotifyUrlPayin] = useState("");
  const [notifyUrlPayout, setNotifyUrlPayout] = useState("");
  const [payinProgramsObj, setPayinProgramsObj] = useState({});
  const [payoutProgramsObj, setPayoutProgramsObj] = useState({});

  const { enqueueSnackbar } = useSnackbar();

  const inputStyle = {
    alignSelf: "center",
    height: 40,
    boxShadow: "none",
    outline: "none",
    paddingLeft: 10,
    boxSizing: "border-box",
    width: "100%",
    backgroundColor: "#FFFFFF",
    color: "black",
    maxWidth: 500,
    minWidth: 250,
    width: 350,
  };
  const containerStyle = {
    padding: 0,
    maxWidth: 500,
    minWidth: 250,
    width: 350,
    height: "40px",
    border: "1px solid #CBCACA",
    borderRadius: "5px",
  };

  useEffect(() => {
    if (clientData) {
      const payoutService = clientData.service.find(
        (e) => e?.serviceType === "payout"
      );
      const payinService = clientData.service.find(
        (e) =>
          e?.serviceType === "payin" ||
          e?.serviceType === "van" ||
          e?.serviceType === "voucher" ||
          e?.serviceType === "van-upi"
      );

      const payinProgramsObj = clientData.programs.find(
        (e) =>
          e?.service_type === "payin" ||
          e?.service_type === "van" ||
          e?.service_type === "voucher" ||
          e?.serviceType === "van-upi"
      );

      const payoutProgramsObj = clientData.programs.find(
        (e) => e?.service_type === "payout"
      );

      const ipWhiteListData = clientData?.ipWhitelist;

      if (payinService) {
        setPayinIpWhitelist(ipWhiteListData);
      }
      if (payoutService) {
        setPayoutIpWhitelist(ipWhiteListData);
      }
      if (payinProgramsObj) {
        setNotifyUrlPayin(payinProgramsObj.notifyUrl);
      }
      if (payoutProgramsObj) {
        setNotifyUrlPayout(payoutProgramsObj.notifyUrl);
      }
      setPayout(payoutService);
      setPayin(payinService);
      setPayinProgramsObj(payinProgramsObj);
      setPayoutProgramsObj(payoutProgramsObj);
    }
  }, [clientData]);

  useEffect(() => {
    let service = [];
    if (
      isEditClicked &&
      (serviceProviderNamepayin ||
        neokredRatepayin ||
        resellerRatepayin ||
        commissionRate1 ||
        type ||
        notifyUrlPayin)
    ) {
      service = [
        {
          serviceProviderName: serviceProviderNamepayin,
          serviceProviderType:
            serviceProviderNamepayin?.toLowerCase() === "neokred"
              ? "voucher"
              : "payin",
          neokredRate: neokredRatepayin,
          resellerRate: resellerRatepayin,
          comissionRate: commissionRate1,
          comissionType: type,
          notifyUrl: notifyUrlPayin,
        },
      ];
    }

    if (
      isEditClicked &&
      (serviceProviderNamepayout ||
        neokredRatepayout ||
        resellerRatepayout ||
        commissionRate2 ||
        type1 ||
        notifyUrlPayout)
    ) {
      service = [
        {
          serviceProviderName: serviceProviderNamepayout,
          serviceProviderType: "payout",
          neokredRate: neokredRatepayout,
          resellerRate: resellerRatepayout,
          comissionRate: commissionRate2,
          comissionType: type1,
          notifyUrl: notifyUrlPayout,
        },
      ];
    }

    if (
      isEditClicked &&
      (serviceProviderNamepayin ||
        neokredRatepayin ||
        resellerRatepayin ||
        commissionRate1 ||
        type ||
        notifyUrlPayin) &&
      (serviceProviderNamepayout ||
        neokredRatepayout ||
        resellerRatepayout ||
        commissionRate2 ||
        type1 ||
        notifyUrlPayout)
    ) {
      service = [
        {
          serviceProviderName: serviceProviderNamepayin,
          serviceProviderType:
            serviceProviderNamepayin?.toLowerCase() === "neokred"
              ? "voucher"
              : "payin",
          neokredRate: neokredRatepayin,
          resellerRate: resellerRatepayin,
          comissionRate: commissionRate1,
          comissionType: type,
          notifyUrl: notifyUrlPayin,
        },
        {
          serviceProviderName: serviceProviderNamepayout,
          serviceProviderType: "payout",
          neokredRate: neokredRatepayout,
          resellerRate: resellerRatepayout,
          comissionRate: commissionRate2,
          comissionType: type1,
          notifyUrl: notifyUrlPayout,
        },
      ];
    }
    onChangeFileds(service);
  }, [
    isEditClicked,
    serviceProviderNamepayin,
    neokredRatepayin,
    resellerRatepayin,
    commissionRate1,
    serviceProviderNamepayout,
    neokredRatepayout,
    resellerRatepayout,
    commissionRate2,
    type,
    type1,
    notifyUrlPayin,
    notifyUrlPayout,
  ]);

  useEffect(() => {
    setServiceType(clientData?.service?.[0]?.serviceType);
  }, []);
  useEffect(() => {
    setPrograms(clientData?.programs);
  }, []);
  const setServiceValues = (service, isPayout) => {
    const {
      serviceProviderName,
      serviceProviderRate,
      neokredRate,
      resellerRate,
      comissionRate,
      comissionType,
      serviceType,
    } = service || {};
    if (isPayout) {
      setServiceProviderNamepayout(serviceProviderName);
      setServiceProviderRatepayout(serviceProviderRate);
      setNeokredRatepayout(neokredRate);
      setResellerratepayout(resellerRate);
      setCommissionRate2(comissionRate);
      setType1(comissionType);
    } else {
      setServiceProviderNamepayin(serviceProviderName);
      setServiceProviderRatepayin(serviceProviderRate);
      setNeokredRatepayin(neokredRate);
      setResellerratepayin(resellerRate);
      setCommissionRate1(comissionRate);
      setType(comissionType);
    }
  };

  useEffect(() => {
    setServiceValues(payin, false);
    setServiceValues(payout, true);
    setProgramsObjValues(payinProgramsObj, false);
    setProgramsObjValues(payoutProgramsObj, true);
  }, [!isEditClicked, payin, payout, payinProgramsObj]);

  const setProgramsObjValues = (obj, serviceType) => {
    if (obj) {
      if (serviceType) {
        setNotifyUrlPayout(obj.notifyUrl);
      } else {
        setNotifyUrlPayin(obj.notifyUrl);
      }
    }
  };

  useEffect(() => {
    if (isEditClicked) {
      setNeokredRatepayin("");
      setResellerratepayin("");
      setNeokredRatepayout("");
      setResellerratepayout("");
      setNotifyUrlPayin("");
      setNotifyUrlPayout("");
    }
  }, [clientData, isEditClicked]);

  useEffect(() => {
    if (payin) {
      setServiceValues(payin, false);
    }
  }, [payin]);

  useEffect(() => {
    if (payout) {
      setServiceValues(payout, true);
    }
  }, [payout]);

  useEffect(() => {
    if (isEditClicked && payinIpWhitelist) {
      onChangeIpwhiteList(payinIpWhitelist);
    }
    if (isEditClicked && payoutIpWhitelist) {
      onChangeIpwhiteList(payoutIpWhitelist);
    }
  }, [isEditClicked, payinIpWhitelist, payoutIpWhitelist]);

  return (
    <div style={{ marginBottom: 30 }}>
      {payin && (
        <div style={{ padding: "20px" }}>
          {serviceProviderNamepayin?.toLowerCase() === "neokred" && (
            <CheckBoxInput
              title={"VOUCHER"}
              checked={"checked"}
              disabled={true}
            />
          )}

          {serviceProviderNamepayin?.toLowerCase() === "payin" && (
            <CheckBoxInput
              title={"PAYIN"}
              checked={"checked"}
              disabled={true}
            />
          )}

          <div
            style={{
              display: "flex",
              flexWrap: "wrap",
              gap: "0px 100px",
            }}
          >
            <div style={{ marginTop: 20 }}>
              <label style={{ fontSize: 14, lineHeight: 2 }}>
                Service Provider Name{" "}
              </label>
              <CustomInput
                disabled={true}
                value={serviceProviderNamepayin}
                onChange={(data) => setServiceProviderNamepayin(data)}
                inputcomponentStyles={{ ...inputStyle }}
                placeholder="Service Provider Name "
                validator="name"
                type="input"
                inputStyles={{
                  ...containerStyle,
                }}
              />
            </div>
            <div style={{ marginTop: 20 }}>
              <label style={{ fontSize: 14, lineHeight: 2 }}>
                Service Provider Rate
              </label>
              <CustomInput
                disabled={true}
                value={serviceProviderRatepayin}
                onChange={(data) => setServiceProviderRatepayin(data)}
                inputcomponentStyles={{ ...inputStyle }}
                placeholder="1%"
                validator="name"
                type="input"
                inputStyles={{
                  ...containerStyle,
                }}
              />
            </div>
            <div style={{ marginTop: 20 }}>
              <label style={{ fontSize: 14, lineHeight: 2 }}>
                Neokred Rate
              </label>
              <div style={{ display: "flex" }}>
                <CustomInput
                  disabled={isEditClicked ? "" : "disabled"}
                  value={neokredRatepayin}
                  onChange={(data) => {
                    setNeokredRatepayin(data);
                  }}
                  inputcomponentStyles={{ ...inputStyle }}
                  placeholder="1%"
                  validator="percentageDecimal"
                  type="input"
                  inputStyles={{
                    ...containerStyle,
                  }}
                />
              </div>
            </div>
            <div style={{ marginTop: 20 }}>
              <label style={{ fontSize: 14, lineHeight: 2 }}>
                Reseller Rate
              </label>
              <CustomInput
                disabled={isEditClicked ? "" : "disabled"}
                value={resellerRatepayin}
                onChange={(data) => setResellerratepayin(data)}
                inputcomponentStyles={{ ...inputStyle }}
                placeholder="1%"
                validator="percentageDecimal"
                type="input"
                inputStyles={{
                  ...containerStyle,
                }}
              />
            </div>
            <div style={{ marginTop: 20 }}>
              <label style={{ fontSize: 14, lineHeight: 2 }}>Notify Url</label>
              <CustomInput
                disabled={isEditClicked ? "" : "disabled"}
                value={notifyUrlPayin}
                onChange={(data) => setNotifyUrlPayin(data)}
                inputcomponentStyles={{ ...inputStyle }}
                placeholder="Notify Url"
                validator="percentageDecimal"
                type="input"
                inputStyles={{
                  ...containerStyle,
                }}
              />
            </div>
            {serviceProviderNamepayin === "Fino" && serviceType === "payin" ? (
              <div style={{ marginTop: 20 }}>
                <label style={{ fontSize: 14, lineHeight: 2 }}>
                  Vpa Substring
                </label>
                <CustomInput
                  disabled={isEditClicked ? "" : "disabled"}
                  value={programs[0]?.vpa_sub_string}
                  // onChange={(data) => setResellerratepayin(data)}
                  inputcomponentStyles={{ ...inputStyle }}
                  placeholder="1%"
                  validator="percentageDecimal"
                  type="input"
                  inputStyles={{
                    ...containerStyle,
                  }}
                />
              </div>
            ) : null}
            {serviceProviderNamepayin === "Fino" ||
            (serviceProviderNamepayin?.toUpperCase() === "IDFC" &&
              serviceType === "payin") ? (
              <div style={{ marginTop: 20 }}>
                <label style={{ fontSize: 14, lineHeight: 2 }}>MCC Code</label>
                <CustomInput
                  disabled={isEditClicked ? "" : "disabled"}
                  value={programs[0]?.mcc}
                  // onChange={(data) => setResellerratepayin(data)}
                  inputcomponentStyles={{ ...inputStyle }}
                  placeholder="1%"
                  validator="percentageDecimal"
                  type="input"
                  inputStyles={{
                    ...containerStyle,
                  }}
                />
              </div>
            ) : null}
          </div>
          <div style={{ margin: "30px 20px 20px 0px" }}>
            {/* <div>Client Rate</div>
            <div style={{ display: "flex", marginTop: 15, gap: 50 }}>
              <RadioButton
                disabled={!isEditClicked}
                name="payinrate"
                title="Flat"
                value="Flat"
                onChange={(val) => {
                  setCurrentValuepayin(val.target.value);
                }}
                defaultChecked={currentValuepayin === "Flat"}
                checked={currentValuepayin?.toLowerCase() === "flat"}
              />
              <RadioButton
                disabled={!isEditClicked}
                name="payinrate"
                title="Slab"
                value="Slab"
                onChange={(val) => {
                  setCurrentValuepayin(val.target.value);
                }}
                defaultChecked={currentValuepayin === "Slab"}
                checked={currentValuepayin?.toLowerCase() === "slab"}
              />
            </div>

            <div
              style={{
                display: "flex",
                alignItems: "center",
                marginTop: 20,
                ...containerStyle,
                padding: "0px 10px",
              }}
            >
              <p style={{ fontSize: "14px" }}>
                {clientRatepayin?.type === "RUPPESS" ? "%" : "%"}
              </p>
              <CustomInput
                disabled={!isEditClicked}
                value={clientRatepayin?.value}
                onChange={(data) => {}}
                inputcomponentStyles={{ ...inputStyle }}
                placeholder="1%"
                validator="name"
                type="input"
                inputStyles={{
                  ...containerStyle,
                  border: "0px",
                  height: 35,
                }}
              />
            </div> */}

            <p style={{}}>Client Rate</p>
            <CommissionContainerPrefill
              styles={{
                width: "343px",
                background: "white",
                minHeight: "71px",
                borderRadius: "6px",
                border: "1px solid #CBCACA",
                backgroundColor: "red",
                PointerEvent: "",
              }}
              innerStyles={{
                marginLeft: "-12px",
                marginTop: "-8px",
              }}
              isEditClicked={isEditClicked}
              onClickNext={(data, flatData, type) => {
                setType(type.toUpperCase());
                if (type === "flat") {
                  setCommissionRate1([flatData]);
                } else {
                  setCommissionRate1(data);
                }

                //setCommissionRate1([flatData]);
              }}
              rate={commissionRate1}
              type={type}
              disabled={isEditClicked ? "" : "disabled"}
              ex={"PAYIN"}
              isFlatRequired={true}
              isSlabRequired={true}
            />
          </div>
          {clientData?.ipWhitelist[0]?.length > 0 && (
            <div>
              <div
                style={{
                  fontSize: "24px",
                  backgroundImage:
                    " linear-gradient(90deg, #4947B8 0%, #FF9700 166.16%)",
                  backgroundSize: "100%",
                  WebkitBackgroundClip: "text",
                  MozBackgroundClip: "text",
                  WebkitTextFillColor: "transparent",
                  MozTextFillColor: "transparent",
                  fontWeight: "600",
                  width: "fit-content",
                  // borderBottom: "1px solid #38369C",
                  paddingBottom: 10,
                  margin: 10,
                }}
              >
                IP Whitelisting
              </div>
              <div
                style={{ borderBottom: "1px solid #38369C", margin: 10 }}
              ></div>
              <div
                style={{
                  marginTop: 20,
                  width: "50%",
                  minWidth: "500px",
                  display: "flex",
                  gap: 10,
                }}
              >
                <div style={{ padding: "20px" }}>
                  <label style={{ fontSize: 14, lineHeight: 2 }}>
                    IP Address(IPV4)
                  </label>
                  <CustomInput
                    disabled={isEditClicked ? "" : "disabled"}
                    value={payinIpWhitelist}
                    onChange={(data) => setPayinIpWhitelist(data)}
                    inputcomponentStyles={{ ...inputStyle }}
                    isEditClicked={isEditClicked}
                    placeholder="IP Address"
                    type="input"
                    inputStyles={{
                      ...containerStyle,
                    }}
                  />
                </div>
                {/* {role === RNC &&
                  status !== RNCREJECTED &&
                  status !== RNCAPPROVED && (
                    <>
                      {loading ? (
                        <div
                          style={{
                            // marginTop: "5px",
                            // marginLeft: "10px",
                            paddingTop: 60,
                          }}
                        >
                          <CustomLoader />
                        </div>
                      ) : (
                        <CustomButton
                          title={urlValidate ? "Verified" : "Validate"}
                          onClick={() => {
                            if (!urlValidate) {
                              setLoading(!loading);
                              // validateAccountWithPennyDrop({
                              //   accNo: remitterAccountNumber,
                              //   ifsc: remitterAccountIfsc,
                              //   name: remitterAccountName,
                              // });
                            }
                          }}
                          styles={{ alignSelf: "flex-end", marginBottom: "20px" }}
                        />
                      )}
                    </>
                  )} */}
              </div>
            </div>
          )}
        </div>
      )}
      {payout && (
        <div style={{ padding: "20px" }}>
          <CheckBoxInput
            title={"PAYOUT"}
            checked={"checked"}
            //disabled={!isEditClicked}
            disabled={true}
          />

          <div
            style={{
              display: "flex",
              flexWrap: "wrap",
              gap: "0px 100px",
            }}
          >
            <div style={{ marginTop: 20 }}>
              <label style={{ fontSize: 14, lineHeight: 2 }}>
                Service Provider Name
              </label>
              <CustomInput
                disabled={true}
                value={serviceProviderNamepayout}
                onChange={(data) => setServiceProviderNamepayout(data)}
                inputcomponentStyles={{ ...inputStyle }}
                placeholder="Service Provider Name "
                validator="name"
                type="input"
                inputStyles={{
                  ...containerStyle,
                }}
              />
            </div>
            <div style={{ marginTop: 20 }}>
              <label style={{ fontSize: 14, lineHeight: 2 }}>
                Service Provider Rate
              </label>
              <CustomInput
                disabled={true}
                value={serviceProviderRatepayout}
                onChange={(data) => setServiceProviderRatepayout(data)}
                inputcomponentStyles={{ ...inputStyle }}
                placeholder="1%"
                validator="name"
                type="input"
                inputStyles={{
                  ...containerStyle,
                }}
              />
            </div>
            <div style={{ marginTop: 20 }}>
              <label style={{ fontSize: 14, lineHeight: 2 }}>
                Neokred Rate
              </label>
              <div style={{ display: "flex" }}>
                <CustomInput
                  disabled={isEditClicked ? "" : "disabled"}
                  value={neokredRatepayout}
                  onChange={(data) => setNeokredRatepayout(data)}
                  inputcomponentStyles={{ ...inputStyle }}
                  placeholder="1%"
                  validator="percentageDecimal"
                  type="input"
                  inputStyles={{
                    ...containerStyle,
                  }}
                />
              </div>
            </div>
            <div style={{ marginTop: 20 }}>
              <label style={{ fontSize: 14, lineHeight: 2 }}>
                Reseller Rate
              </label>
              <CustomInput
                disabled={isEditClicked ? "" : "disabled"}
                value={resellerRatepayout}
                onChange={(data) => setResellerratepayout(data)}
                inputcomponentStyles={{ ...inputStyle }}
                placeholder="1%"
                validator="percentageDecimal"
                type="input"
                inputStyles={{
                  ...containerStyle,
                }}
              />
            </div>
            <div style={{ marginTop: 20 }}>
              <label style={{ fontSize: 14, lineHeight: 2 }}>Notify Url</label>
              <CustomInput
                disabled={isEditClicked ? "" : "disabled"}
                value={notifyUrlPayout}
                onChange={(data) => setNotifyUrlPayout(data)}
                inputcomponentStyles={{ ...inputStyle }}
                placeholder="Notify Url"
                validator="percentageDecimal"
                type="input"
                inputStyles={{
                  ...containerStyle,
                }}
              />
            </div>
          </div>
          <div>
            <p style={{ margin: "30px 20px 20px 0px" }}>Client Rate</p>
            <CommissionContainerPrefill
              disabled={isEditClicked ? "" : "disabled"}
              styles={{
                width: "343px",
                background: "white",
                minHeight: "71px",
                borderRadius: "6px",
                border: "1px solid #CBCACA",
              }}
              innerStyles={{
                marginLeft: "-12px",
                marginTop: "-8px",
              }}
              onClickNext={(data, flatData, type) => {
                setType1(type?.toUpperCase());
                if (type === "flat") {
                  setCommissionRate2([flatData]);
                } else {
                  setCommissionRate2(data);
                }
              }}
              rate={commissionRate2}
              ex={"PAYOUT"}
              isEditClicked={isEditClicked}
              isFlatRequired={serviceType === "van" ? false : true}
              isSlabRequired={true}
              type={type1}
            />
          </div>

          {/* <div style={{ margin: "30px 20px 20px 0px" }}>
            <div>Client Rate</div>
            <div style={{ display: "flex", marginTop: 15, gap: 50 }}>
              <RadioButton
                name="payoutrate"
                title="Flat"
                value="Flat"
                onChange={(val) => {
                  // setCurrentValuepayout(val.target.value);
                }}
                disabled={!isEditClicked}
                // defaultChecked={currentValuepayout?.toLowerCase() === "flat"}
              />
              <RadioButton
                name="payoutrate"
                title="Slab"
                value="Slab"
                onChange={(val) => {
                  // setCurrentValuepayout(val.target.value);
                }}
                disabled={!isEditClicked}
                // defaultChecked={currentValuepayout?.toLowerCase() === "slab"}
              />
            </div>

            <div
              style={{
                display: "flex",
                alignItems: "center",
                marginTop: 20,

                ...containerStyle,
                padding: "0px 10px",
              }}
            >
              <p style={{ fontSize: "14px" }}>
                {clientRatepayout?.type === "RUPPESS" ? "%" : "%"}
              </p>
              <CustomInput
                disabled={!isEditClicked}
                value={clientRatepayout?.value}
                onChange={(data) => {}}
                inputcomponentStyles={{ ...inputStyle }}
                placeholder="1%"
                validator="name"
                type="input"
                inputStyles={{
                  ...containerStyle,
                  border: "0px",
                  height: 35,
                }}
              />
            </div>
          </div> */}
          {clientData?.ipWhitelist[0]?.length > 0 && (
            <div>
              <div
                style={{
                  fontSize: "24px",
                  backgroundImage:
                    " linear-gradient(90deg, #4947B8 0%, #FF9700 166.16%)",
                  backgroundSize: "100%",
                  WebkitBackgroundClip: "text",
                  MozBackgroundClip: "text",
                  WebkitTextFillColor: "transparent",
                  MozTextFillColor: "transparent",
                  fontWeight: "600",
                  width: "fit-content",
                  // borderBottom: "1px solid #38369C",
                  paddingBottom: 10,
                  margin: 10,
                }}
              >
                IP Whitelisting
              </div>
              <div
                style={{ borderBottom: "1px solid #38369C", margin: 10 }}
              ></div>
              <div
                style={{
                  marginTop: 20,
                  width: "50%",
                  minWidth: "500px",
                  display: "flex",
                  gap: 10,
                }}
              >
                <div style={{ padding: "20px" }}>
                  <label style={{ fontSize: 14, lineHeight: 2 }}>
                    Enter IP
                  </label>
                  <CustomInput
                    disabled={isEditClicked ? "" : "disabled"}
                    value={payoutIpWhitelist}
                    onChange={(data) => setPayoutIpWhitelist(data)}
                    inputcomponentStyles={{ ...inputStyle }}
                    placeholder="Enter IP"
                    // validator="pan"
                    isEditClicked={isEditClicked}
                    type="input"
                    inputStyles={{
                      ...containerStyle,
                    }}
                  />
                </div>
                {/* {role === RNC &&
                  status !== RNCREJECTED &&
                  status !== RNCAPPROVED && (
                    <>
                      {loading ? (
                        <div
                          style={{
                            // marginTop: "5px",
                            // marginLeft: "10px",
                            paddingTop: 60,
                          }}
                        >
                          <CustomLoader />
                        </div>
                      ) : (
                        <CustomButton
                          title={urlValidate ? "Verified" : "Validate"}
                          onClick={() => {
                            if (!urlValidate) {
                              setLoading(!loading);
                              // validateAccountWithPennyDrop({
                              //   accNo: remitterAccountNumber,
                              //   ifsc: remitterAccountIfsc,
                              //   name: remitterAccountName,
                              // });
                            }
                          }}
                          styles={{ alignSelf: "flex-end", marginBottom: "20px" }}
                        />
                      )}
                    </>
                  )} */}
              </div>
            </div>
          )}
        </div>
      )}

      {!payin && !payout && <p>Not found</p>}
      {/* <div>
        <div
          style={{
            fontSize: "24px",
            backgroundImage:
              " linear-gradient(90deg, #4947B8 0%, #FF9700 166.16%)",
            backgroundSize: "100%",
            WebkitBackgroundClip: "text",
            MozBackgroundClip: "text",
            WebkitTextFillColor: "transparent",
            MozTextFillColor: "transparent",
            fontWeight: "600",
            width: "fit-content",
            // borderBottom: "1px solid #38369C",
            paddingBottom: 10,
            margin: 10,
          }}
        >
          IP Whitelisting
        </div>
        <div style={{ borderBottom: "1px solid #38369C", margin: 10 }}></div>
        <div
          style={{
            marginTop: 20,
            width: "50%",
            minWidth: "500px",
            display: "flex",
            gap: 10,
          }}
        >
          <div style={{ padding: "20px" }}>
            <label style={{ fontSize: 14, lineHeight: 2 }}>Enter URL</label>
            <CustomInput
              disabled={isEditClicked ? "" : "disabled"}
              value={url}
              onChange={(data) => setUrl(data)}
              inputcomponentStyles={{ ...inputStyle }}
              placeholder="Enter URL"
              // validator="pan"
              type="input"
              inputStyles={{
                ...containerStyle,
              }}
            />
          </div>
          {role === RNC && status !== RNCREJECTED && status !== RNCAPPROVED && (
            <>
              {loading ? (
                <div
                  style={{
                    // marginTop: "5px",
                    // marginLeft: "10px",
                    paddingTop: 60,
                  }}
                >
                  <CustomLoader />
                </div>
              ) : (
                <CustomButton
                  title={urlValidate ? "Verified" : "Validate"}
                  onClick={() => {
                    if (!urlValidate) {
                      setLoading(!loading);
                      // validateAccountWithPennyDrop({
                      //   accNo: remitterAccountNumber,
                      //   ifsc: remitterAccountIfsc,
                      //   name: remitterAccountName,
                      // });
                    }
                  }}
                  styles={{ alignSelf: "flex-end", marginBottom: "20px" }}
                />
              )}
            </>
          )}
        </div>
      </div> */}
    </div>
  );
}

export default ServiceType;
